import {
    Button,
    Card,
    Col,
    Collapse,
    DatePicker,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Pagination,
    Row,
    Select,
    Space,
    Spin,
    Table,
    Tag
} from "antd";
import {CloseOutlined, DownloadOutlined, EyeOutlined} from "@ant-design/icons";
import React, {useEffect, useRef, useState} from "react";

import {toNumber} from "lodash";

import dayjs from "dayjs";
import CommonFunction from "../../../../util/CommonFunction";
import {
    MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR,
    MSG_FAILED_TO_FETCH_BANK_CHANGE_DETAILS_HISTORY_ERROR,
    MSG_FAILED_TO_FETCH_BANK_LIST_ERROR,
    MSG_FAILED_TO_FETCH_CONTACT_CHANGE_DETAILS_HISTORY_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR
} from "../../../../util/Messages";
import {ChangeRequestFilterDto} from "../../../../dto/admin/ChangeRequestFilterDto";
import {
    CHANGE_REQUEST_RECORD_STATUS,
    COMMON_DROPDOWN,
    DOCUMENT_TYPES,
    NOT_AVAILABLE,
    PARAMETER_LIST,
    YYYY_MM_DD,
    YYYY_MM_DD_HH_MM
} from "../../../../util/Constants";
import {AddressDto} from "../../../../dto/AddressDto";
import {DropdownListDto} from "../../../../dto/DropdownListDto";
import {BankDetailDto} from "../../../../dto/BankDetailDto";
import {InputDropdownParameterDto} from "../../../../dto/InputDropdownParameterDto";
import customerService from "../../../../service/customerService";
import ErrorHandler from "../../../../util/ErrorHandler";
import documentService from "../../../../service/documentService";
import {DefaultDocumentDto} from "../../../../dto/DefaultDocumentDto";
import {UploadedDocumentDetailDto} from "../../../../dto/UploadedDocumentDetailDto";
import customerChangeRequestAdminService from "../../../../service/customerChangeRequestAdminService";
import TextArea from "antd/es/input/TextArea";
import PreviewModalComp from "../../../common/preview/PreviewModalComp";

const {Panel} = Collapse;
const {RangePicker} = DatePicker;

const BankDetailChangeHistoryComp = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [isModalLoading, setModalLoading] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 10,
    });

    const [filter, setFilter] = useState<ChangeRequestFilterDto>({
        recordStatus: null,
        type: null,
        submittedDateTo: null,
        submittedDateFrom: null,
        cin: null,
        page: 1,
        size: 10,
        sort: ['createdDate', 'desc']
    });
    const [bankList, setBankList] = useState<DropdownListDto[]>([]);
    const [branchListPrimary, setBranchListPrimary] = useState<DropdownListDto[]>([]);
    const [branchListSec, setBranchListSecondary] = useState<DropdownListDto[]>([]);
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [isPrimaryInfoAvailable, setIsPrimaryInfoAvailable] = useState(false);
    const [isSecondaryInfoAvailable, setIsSecondaryInfoAvailable] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [isShowRejectReason, setCanShowRejectReason] = useState<boolean>(false)
    const [bankDetailChangeHistoryList, setBankDetailChangeHistoryList] = useState<AddressDto[]>()

    const [primaryBankAccForm] = Form.useForm();
    const [secondaryBankAccForm] = Form.useForm();
    const [rejectReasonForm] = Form.useForm()
    const [form] = Form.useForm();


    const [position2, setPosition2] = useState({x: 100, y: 20});
    const modalRef2 = useRef<HTMLDivElement | null>(null);
    const draggingRef2 = useRef<{ offsetX: number; offsetY: number } | null>(null);

    const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        if ((e.target as HTMLElement).classList.contains('draggable-modal-title-area')) {
            if (modalRef2.current) {
                const rect = modalRef2.current.getBoundingClientRect();
                draggingRef2.current = {offsetX: e.clientX - rect.left, offsetY: e.clientY - rect.top};
            }
        }
    };

    // Drag the modal
    const onMouseMove = (e: MouseEvent) => {
        if (draggingRef2.current) {
            const {offsetX, offsetY} = draggingRef2.current;
            setPosition2({x: e.clientX - offsetX, y: e.clientY - offsetY});
        }
    };

    // Stop dragging
    const onMouseUp = () => {
        draggingRef2.current = null;
    };

    useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);
    useEffect(() => {
        fetchAllBankChangeHistoryList(pagination.current, pagination.pageSize, filter)

    }, []);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'groupId',
            key: 'groupId',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'CIN',
            dataIndex: 'cin',
            key: 'cin',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            align: 'center',
            render: (text: string) => (
                <>
                    {'PRIMARY' == text ?
                        <Tag color="success">
                            Primary
                        </Tag> :
                        <Tag color="warning">
                            Secondary
                        </Tag>
                    }
                </>
            ),
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Created Date Time',
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Modified By',
            dataIndex: 'lastModifiedBy',
            key: 'lastModifiedBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Modified Date Time',
            dataIndex: 'lastModifiedDate',
            key: 'lastModifiedDate',
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Status',
            dataIndex: 'recordStatus',
            key: 'recordStatus',
            align: 'center',
            render: (text: any, rec: any) => {
                return (
                    <Tag className={'drl-tbl-tag'}
                         color={getColor(text)} key={text}>
                        {text.toUpperCase()}
                    </Tag>
                )
            }
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (rec: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={() => fetchBankChangeHistoryDetail(rec.cin, rec.id)}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];
    const fetchBankChangeHistoryDetail = (cin: string, id: number) => {
        setLoading(true)

        customerChangeRequestAdminService.getBankChangeRequestDetails(cin, 0 ,id).then((res => {
            if (res.data !== null && res.data.results) {
                showModal(res.data.results.bankDetailDtoList)
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_BANK_CHANGE_DETAILS_HISTORY_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }
    const showModal = (record: BankDetailDto[]) => {
        getBankList()
        setModalLoading(true)
        setFieldValues(record)

    };

    const getColor = (identificationSourceType: string) => {
        switch (identificationSourceType) {
            case CHANGE_REQUEST_RECORD_STATUS.ACCEPTED: {
                return 'green';
            }
            case CHANGE_REQUEST_RECORD_STATUS.SUBMITTED: {
                return '#faad14';
            }
            case CHANGE_REQUEST_RECORD_STATUS.REJECTED: {
                return '#cf1322';
            }
            case CHANGE_REQUEST_RECORD_STATUS.CANCELLED: {
                return '#dfd3d4';
            }
        }
    }

    const onReset = () => {
        form.resetFields();
        let filterDto: ChangeRequestFilterDto = {
            cin: null,
            type: null,
            recordStatus: null,
            submittedDateFrom: null,
            submittedDateTo: null,
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        setPagination({
            ...pagination,
            current: 1,
        });
        fetchAllBankChangeHistoryList(1, pagination.pageSize, filterDto);
    }
    const onFilter = (values: any) => {

        let submittedDateFrom = null
        let submittedDateTo = null

        if (values.createdDate) {
            submittedDateFrom = values.createdDate[0].format(YYYY_MM_DD)
            submittedDateTo = values.createdDate[1].format(YYYY_MM_DD)
        }

        let filterDto: ChangeRequestFilterDto = {
            cin: checkUndefined(values.cin),
            recordStatus: values.recordStatus,
            type: values.type,
            submittedDateFrom: submittedDateFrom,
            submittedDateTo: submittedDateTo,
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        fetchAllBankChangeHistoryList(1, pagination.pageSize, filterDto);
    }
    const checkUndefined = (value: any) => {
        return value == undefined || value == "" ? null : value
    }

    const getBankList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BANK_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        loadCommonDropdownDataList(inputDropdownParameterDto, COMMON_DROPDOWN.BANK_LIST);
    }
    const getBranchList = (selectedBank: number, isPrimaryAcc: boolean) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BRANCH_LIST,
            findTextValue: "",
            parameterList: [[selectedBank], [PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                if (isPrimaryAcc) {
                    setBranchListPrimary(res.data.results.activeItemList)
                } else {
                    setBranchListSecondary(res.data.results.activeItemList)
                }
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setType = (type: COMMON_DROPDOWN, result: DropdownListDto[]) => {
        if (type == COMMON_DROPDOWN.BANK_LIST) {
            setBankList(result)
        }
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto, type: COMMON_DROPDOWN) => {
        customerService.getCommonDropdown(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                setType(type, res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setFieldValues = (bankDetailList: BankDetailDto[]) => {
        bankDetailList.map((bankDetailDto) => {
            if (bankDetailDto.bankAccountType === "PRIMARY") {
                setPrimaryBankInfo(bankDetailDto)
                setIsModalOpen(true);
            } else {
                setSecondaryBankInfo(bankDetailDto)
                setIsModalOpen(true);
            }
            setCanShowRejectReason("REJECTED" === bankDetailDto.recordStatus)
            rejectReasonForm.setFieldsValue({
                rejectReason: bankDetailDto.rejectReason
            })
        })

    }

    const setPrimaryBankInfo = (primaryAcc: BankDetailDto) => {
        setIsPrimaryInfoAvailable(true)
        getBranchList(primaryAcc.bankId, true)
        // setJobNumber(primaryAcc.jobNumber ?? "")
        primaryBankAccForm.setFieldsValue(
            {
                id: primaryAcc.id,
                accountHolderName: primaryAcc.accountHolderName,
                accountNo: primaryAcc.accountNo,
                bankId: toNumber(primaryAcc.bankId),
                branchId: toNumber(primaryAcc.branchId),

            }
        )
        loadUploadedDocumentsById(primaryAcc.jobNumber, primaryAcc.bankStatementDocId,
            [primaryAcc.recordStatus === "ACCEPTED" ? 'PBCL' : 'PBCL_TEMP'])
        setModalLoading(false)
    }
    const setSecondaryBankInfo = (secondaryAcc: BankDetailDto) => {
        setIsSecondaryInfoAvailable(true)
        getBranchList(secondaryAcc.bankId, false)
        secondaryBankAccForm.setFieldsValue(
            {
                id: secondaryAcc.id,
                accountHolderName: secondaryAcc.accountHolderName,
                accountNo: secondaryAcc.accountNo,
                branchId: secondaryAcc.branchId,
                bankId: secondaryAcc.bankId,

            }
        )
        loadUploadedDocumentsById(secondaryAcc.jobNumber, secondaryAcc.bankStatementDocId,
            [secondaryAcc.recordStatus === "ACCEPTED" ? 'SBCL' : 'SBCL_TEMP'])
        setModalLoading(false)
    }

    const handleCancel = () => {
        setPosition2({x: 100, y: 20});
        setIsModalOpen(false);
        setPreviewOpen(false);
        resetModalFormFields();
    };

    const resetModalFormFields = () => {
        secondaryBankAccForm.resetFields()
        primaryBankAccForm.resetFields()

        setIsSecondaryInfoAvailable(false)
        setIsPrimaryInfoAvailable(false)
    }

    const loadUploadedDocumentsById = (jobNo: number, docId: number, docTypeCode: string[]) => {
        documentService.getUploadDocumentListByTypeAndUploadedDocId(jobNo, docId, docTypeCode).then(res => {
            if (res.data !== null && res.data.results.length > 0) {
                createUploadedDocuments(res.data.results[0].uploadDocumentDetailDto, res.data.results[0].documentTypeId)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        });
    };

    const [tempPrimaryBankAccDoc, setTempPrimaryBankDoc] = useState<DefaultDocumentDto[]>()
    const [tempSecBankAccDOc, setTempSecBankAccDOc] = useState<DefaultDocumentDto[]>()

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.PBCL_TEMP || documentTypeId == DOCUMENT_TYPES.PBCL) {
            setTempPrimaryBankDoc(defaultFileList)
            secondaryBankAccForm.setFieldsValue({uploadUtilityBill: defaultFileList})
        } else if (documentTypeId == DOCUMENT_TYPES.SBCL_TEMP || documentTypeId == DOCUMENT_TYPES.SBCL) {
            setTempSecBankAccDOc(defaultFileList)
            secondaryBankAccForm.setFieldsValue({uploadAdditional: defaultFileList})

        }
    }
    const fetchAllBankChangeHistoryList = (page: number, pageSize: number, filterDto: ChangeRequestFilterDto) => {
        setLoading(true)

        filterDto.page = page - 1;
        filterDto.size = pageSize;

        customerChangeRequestAdminService.bankChangeRequestHistory(filterDto).then((res => {
            if (res.data !== null && res.data.results) {
                let results = res.data.results;
                setBankDetailChangeHistoryList(results.requestAdminHistoryDtos)
                setPagination({
                    current: results.page + 1, // Adjusting to be 1-based index
                    pageSize: results.size,
                    total: results.allCount,
                });
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_CONTACT_CHANGE_DETAILS_HISTORY_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const getFormItemSet = (isPrimary: boolean) => {
        return < >
            <div style={{display: "none"}}>
                <Form.Item
                    label=""
                    name={"id"}>
                    <Input/>
                </Form.Item>
            </div>
            <Col span={12}>
                <Form.Item
                    label="Name of the Bank"
                    name={"bankId"}>
                    <Select placement='bottomLeft'
                            placeholder={"Select bank name"}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, option: {
                                label: any;
                            }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                            getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                            options={bankList}
                    />

                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Branch"
                    name={"branchId"}>
                    <Select placement='bottomLeft' defaultSelected={""}
                            placeholder={"Select branch"}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, option: {
                                label: any;
                            }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                            getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                            options={isPrimary ? branchListPrimary : branchListSec}
                    />

                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Account Number"
                    name={"accountNo"}>
                    <Input placeholder={"Enter account number"}/>
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Account Holder`s Name"
                    name={"accountHolderName"}>
                    <Input type="text" placeholder={"Enter account holder`s name"}/>
                </Form.Item>
            </Col>

        </>
    }
    const openModal = (documentId: string, docTypeName: string) => {
        setLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPosition2({x: 100, y: 20});
                setPreviewOpen(true);
                setIsModalOpen(true);
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    const handlePaginationChange = (page: number, pageSize: number) => {
        fetchAllBankChangeHistoryList(page, pageSize, filter);
    };

    return (
        <>
            <Row gutter={[24, 12]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Collapse className={'margin_bottom_20'}>
                        <Panel header="Filter History" key="1">
                            <Form
                                layout={"vertical"}
                                form={form}
                                onFinish={onFilter}
                            >
                                <Row gutter={[16, 0]}>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="cin" label="CIN">
                                            <Input placeholder={'Enter CIN'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="type" label="Type">
                                            <Select style={{width: '100%'}} defaultValue="All"
                                                    options={[
                                                        {value: null, label: 'All'},
                                                        {value: 'PRIMARY', label: 'Primary'},
                                                        {value: "SECONDARY", label: 'Secondary'}
                                                    ]}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="recordStatus" label="Status">
                                            <Select style={{width: '100%'}} defaultValue="All"
                                                    options={[
                                                        {value: null, label: 'All'},
                                                        {value: 'ACCEPTED', label: 'Accepted'},
                                                        {value: 'REJECTED', label: 'Rejected'},
                                                        {value: 'CANCELLED', label: 'Cancelled'}]}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="Created Date" name="createdDate">
                                            <RangePicker placeholder={["From Date", "To Date"]}
                                                         style={{width: '100%'}}/>

                                        </Form.Item>
                                    </Col>

                                </Row>
                                <Row gutter={[16, 0]}>
                                    <Col span={24}>
                                        <Space style={{float: 'right'}}>
                                            <Button style={{
                                                width: 120,
                                                marginRight: 8
                                            }} onClick={onReset}>Reset</Button>
                                            <Button type="success"
                                                    htmlType="submit"
                                                    style={{
                                                        width: 120,
                                                        background: "#FF7400",
                                                        color: "white",
                                                    }}>Filter</Button>
                                        </Space>
                                    </Col>
                                </Row>
                            </Form>
                        </Panel>
                    </Collapse>
                </Col>
                <Col span={24}>
                    <Table columns={columns} dataSource={bankDetailChangeHistoryList} pagination={false}
                           loading={loading}
                           scroll={{x: 'max-content'}}/>
                    <br/>
                    <Space style={{float: 'right'}}>
                        <Pagination
                            total={pagination.total ?? 0}
                            showTotal={(total: number) => `Total ${total} items`}
                            defaultPageSize={10}
                            defaultCurrent={pagination.current}
                            current={pagination.current}
                            onChange={handlePaginationChange}
                        />
                    </Space>
                </Col>
                <Modal
                    title={'Bank Details Update Request History'}
                    style={{top: 0, right: 0, margin: 20, marginTop: 20, position: 'absolute'}}
                    maskStyle={{top: 0, left: 0}}
                    open={isModalOpen} footer={null} onCancel={handleCancel} maskClosable={false}
                    className={'modal-body-scroll-only disabled-data-show-inputs-container'}
                    width={'50vw'}
                >
                    <Spin spinning={isModalLoading}>


                        <Row gutter={[24, 12]}
                             className={'form-item-mb-12 modal-body-scroll-only-main-row compare-modal-height'}>

                            {
                                isPrimaryInfoAvailable ?
                                    <Col span={24}>
                                        <Card title="Primary Bank Account Details" size={'small'}>
                                            <Form
                                                className='form-input'
                                                layout={"vertical"}
                                                form={primaryBankAccForm}
                                                disabled
                                            >
                                                <Row gutter={[12, 0]}>
                                                    {
                                                        getFormItemSet(true)

                                                    }
                                                    <Col span={12}>
                                                        <Form.Item className={'form-item-label-only'}
                                                                   label="Primary Bank Confirmation">
                                                        </Form.Item>

                                                        <div className='utility_bill img-nic' style={{width: '94%'}}>
                                                            <div className='utulity_bill_icon_div'>
                                                                <div className="img_div">
                                                                    <img
                                                                        src={tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].thumbUrl : ''}
                                                                        alt=""/>
                                                                </div>
                                                                <div className='name_div'>
                                                                    <h5>{tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].name : ''}</h5>
                                                                </div>
                                                            </div>
                                                            <Button disabled={false}
                                                                    onClick={() => openModal(
                                                                        tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].uid : '',
                                                                        tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].name : '')}
                                                                    className='doc-view-btn'><EyeOutlined/></Button>
                                                        </div>

                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Card>
                                    </Col> : ''
                            }


                            {
                                isSecondaryInfoAvailable ?
                                    <Col span={24}>
                                        <Card title="Secondary Bank Account Details" size={'small'}>
                                            <Form
                                                className='form-input'
                                                layout={"vertical"}
                                                form={secondaryBankAccForm}
                                                disabled
                                            >
                                                <Row gutter={[12, 0]}>
                                                    {getFormItemSet(false)}

                                                    <Col span={12}>
                                                        <Form.Item className={'form-item-label-only'}
                                                                   label="Secondary Bank Confirmation">
                                                        </Form.Item>
                                                        <div className='utility_bill img-nic' style={{width: '94%'}}>
                                                            <div className='utulity_bill_icon_div'>
                                                                <div className="img_div">
                                                                    <img
                                                                        src={tempSecBankAccDOc ? tempSecBankAccDOc[0].thumbUrl : ''}
                                                                        alt=""/>
                                                                </div>
                                                                <div className='name_div'>
                                                                    <h5>{tempSecBankAccDOc ? tempSecBankAccDOc[0].name : ''}</h5>
                                                                </div>
                                                            </div>
                                                            <Button disabled={false}
                                                                    onClick={() => openModal(
                                                                        tempSecBankAccDOc ? tempSecBankAccDOc[0].uid : '',
                                                                        tempSecBankAccDOc ? tempSecBankAccDOc[0].name : '')}
                                                                    className='doc-view-btn'><EyeOutlined/></Button>
                                                        </div>

                                                    </Col>

                                                </Row>
                                            </Form>
                                        </Card>
                                    </Col> : ''
                            }
                            {isShowRejectReason ?
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Divider></Divider>

                                    <Form form={rejectReasonForm}
                                          className='form-input'
                                          layout={"vertical"}
                                    >
                                        <Form.Item

                                            name={"rejectReason"}
                                            label={"Reject Reason"}>
                                            <TextArea disabled bordered={true}/>
                                        </Form.Item>
                                    </Form>
                                </Col>
                                :
                                <></>
                            }

                        </Row>
                    </Spin>
                </Modal>

                {previewOpen &&
                    <div
                        ref={modalRef2}
                        className="draggable-modal"
                        style={{
                            position: 'fixed',
                            top: position2.y,
                            left: position2.x,
                            zIndex: 100000,
                            width: '40vw'
                        }}
                        onMouseDown={onMouseDown}
                    >
                        <div className="draggable-modal-title-area">
                            <span className={'modal-title'}>{previewTitle}</span>
                            <Button icon={<CloseOutlined/>} size={'small'} onClick={handlePreviewCancel}/>
                        </div>
                        <div className="modal-body-area compare-preview-modal-height">
                            <PreviewModalComp docURL={docURL}/>
                        </div>
                        <div className="modal-footer-area">
                            <Button type="primary" icon={<DownloadOutlined/>}
                                    style={{background: '#FF7400', height: 40}}
                                    htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                                Download
                            </Button>
                        </div>
                    </div>
                }

            </Row>

        </>
    )
}
export default BankDetailChangeHistoryComp;